import React, { useEffect } from 'react'
import classNames from 'classnames'
import { ContainedNavItemProps } from '../'
import { NavLink } from 'react-router-dom'
import useClickOutside from '#src/hooks/useClickOutside'
import styles from '../styles.css'

const NavItem: React.FC<ContainedNavItemProps> = ({
  to,
  isActive,
  testId,
  menuOptions,
  menuPosition,
  isNavItemActive,
  onNavItemClicked,
  onNavItemClickedAway,
  onStaticAction,
  children,
  onActiveChanged,
  ...rest
}) => {
  const navItemHasMenu = !!menuOptions

  const liRef = useClickOutside<HTMLLIElement>(() => {
    if (isNavItemActive) {
      onNavItemClickedAway()
    }
  })

  useEffect(() => {
    onActiveChanged && onActiveChanged(isNavItemActive)
  }, [isNavItemActive])

  return (
    <li
      ref={liRef}
      className={styles.navItem}
      onClick={() => {
        if (!navItemHasMenu) {
          onStaticAction && onStaticAction()
        } else {
          onNavItemClicked()
        }
      }}
    >
      {to && !navItemHasMenu ? (
        <NavLink
          to={to}
          className={styles.navItemLink}
          activeClassName={styles.navItemLinkActive}
          isActive={isActive}
          data-testid={testId}
          {...rest}
        >
          <div className={styles.navItemHighlight}>{children}</div>
        </NavLink>
      ) : (
        <span className={styles.navItemLink} data-testid={testId}>
          <div className={styles.navItemHighlight}>{children}</div>
        </span>
      )}
      {isNavItemActive && menuOptions && (
        <ul
          className={classNames(styles.menu, {
            [styles.menuLeft]: menuPosition === 'left',
            // Serve this as a default since we can't make this required
            [styles.menuRight]: menuPosition !== 'left'
          })}
        >
          {menuOptions}
        </ul>
      )}
    </li>
  )
}

export default NavItem
